import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import messages from './messages';

const SUCCESS_REDIRECT = '/o/profile';

class FormSuccessPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timer: 3000
        };
    }

    componentDidMount() {
        window.setInterval(() => {
            if (this.state.timer > 0) {
                this.setState({timer: this.state.timer - 1000});
            }
            else {
                // Need to clear state (why? Something buggy after finishing a typeform)
                window.location.pathname = SUCCESS_REDIRECT;
                //this.props.history.push(SUCCESS_REDIRECT);
            }
        }, 1000);
    }

    render() {
        return (
            <div className="hero is-fullheight alva-bg">
                <div className="hero-body">
                    <div className="container">
                        <h1><FormattedMessage {...messages.title}/></h1>
                        <p><FormattedMessage {...messages.text}/> <strong>{Math.round(this.state.timer / 1000)}</strong>...</p>
                    </div>
                </div>
            </div>
        );
    }
}

FormSuccessPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    })
};

export default withRouter(FormSuccessPage);
